import { useEffect, useSyncExternalStore } from 'react';
import { useLocation } from 'react-router-dom';
import { MiniFormDialog } from './MiniFormDialog';
import { miniFormStore } from './miniFormStore';

/**
 * Місце міні-форми в оболонці (монтується один раз): показує запит miniFormStore (model.openMini аналітичних подань); перехід на іншу
 * сторінку закриває форму.
 */
export function MiniFormHost() {
  const request = useSyncExternalStore(miniFormStore.subscribe, miniFormStore.get, miniFormStore.get);
  const { pathname } = useLocation();
  useEffect(() => { miniFormStore.close(); }, [pathname]);
  return request ? <MiniFormDialog key={request.id} ws={request.ws} target={request} onClose={miniFormStore.close} /> : null;
}
